<template>
    <div class="row">
        <help-modal/>
        <div class="col-xl-12">
            <div class="ibox form">
                <div class="ibox-title ibox-grey">
                    <h4>{{ __('chart_params') }}</h4>
                    <div class="ibox-tools">
                        <button-open-help-modal :in-extra-div="false" :helpName="analyzeType == 'sell'? 'ASA-008' : 'ASB-008'"/>
                    </div>
                </div>

                <div class="ibox-content">
                    <div class="row">
                        <div class="col-2">
                            {{ __('chart') }}
                        </div>
                        <div class="col-2">
                            <select2 class="vue-select" v-model="chartType" @change="handleChartTypeChange()" style="width: 100%"
                                     :options="chartOptions"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isSimpleWithDefineXAxis">
                        <div class="col-2">
                            {{ __('values_x_axis_is') }}
                        </div>
                        <div class="col-2">
                            <select2 style="width: 100%" class="vue-select" v-model="firstOption"  :settings="selectSettings" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isSimpleWithDefineBars">
                        <div class="col-2">
                            {{ __('bar_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isSimpleWithSlice">
                        <div class="col-2">
                            {{ __('slice_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isSimpleRadar">
                        <div class="col-2">
                            {{ __('arms_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isMultiLine">
                        <div class="col-2">
                            {{ __('line_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isMultiLine">
                        <div class="col-2">
                            {{ __('values_x_axis_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isLineSynchronized">
                        <div class="col-2">
                            {{ __('separate_chart_as') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isLineSynchronized">
                        <div class="col-2">
                            {{ __('values_x_axis_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isColumnBasic">
                        <div class="col-2">
                            {{ __('columns_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isColumnBasic">
                        <div class="col-2">
                            {{ __('values_x_axis_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>

                    <div class="row mt-1" v-if="isStackedColumn">
                        <div class="col-2">
                            {{ __('parts_of_columns_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isStackedColumn">
                        <div class="col-2">
                            {{ __('values_x_axis_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isBarGrouped">
                        <div class="col-2">
                            {{ __('bar_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isBarGrouped">
                        <div class="col-2">
                            {{ __('values_y_axis_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>

                    <div class="row mt-1" v-if="isStackedBar">
                        <div class="col-2">
                            {{ __('parts_of_bars_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isStackedBar">
                        <div class="col-2">
                            {{ __('values_y_axis_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isRadarMultiSeries">
                        <div class="col-2">
                            {{ __('arms_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isRadarMultiSeries">
                        <div class="col-2">
                            {{ __('series_data_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isAreaBasicMultiOrColumnWithDataLabelMulti">
                        <div class="col-2">
                            {{ __('separate_chart_as') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isAreaBasicMultiOrColumnWithDataLabelMulti">
                        <div class="col-2">
                            {{ __('values_x_axis_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isSimplePieOrDonutMulti">
                        <div class="col-2">
                            {{ __('separate_chart_as') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isSimplePieOrDonutMulti">
                        <div class="col-2">
                            {{ __('slice_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>

                    <div class="row mt-1" v-if="isLineManyMulti">
                        <div class="col-2">
                            {{ __('separate_chart_as') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isLineManyMulti">
                        <div class="col-2">
                            {{ __('line_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isLineManyMulti">
                        <div class="col-2">
                            {{ __('values_x_axis_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="thirdOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>

                    <div class="row mt-1" v-if="isColumnBasicMulti">
                        <div class="col-2">
                            {{ __('separate_chart_as') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isColumnBasicMulti">
                        <div class="col-2">
                            {{ __('columns_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isColumnBasicMulti">
                        <div class="col-2">
                            {{ __('values_x_axis_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="thirdOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>


                    <div class="row mt-1" v-if="isStockedColumnMulti">
                        <div class="col-2">
                            {{ __('separate_chart_as') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isStockedColumnMulti">
                        <div class="col-2">
                            {{ __('parts_of_columns_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isStockedColumnMulti">
                        <div class="col-2">
                            {{ __('values_x_axis_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="thirdOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>

                    <div class="row mt-1" v-if="isRadarMultiSeriesMulti">
                        <div class="col-2">
                            {{ __('separate_chart_as') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="firstOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isRadarMultiSeriesMulti">
                        <div class="col-2">
                            {{ __('arms_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="secondOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="isRadarMultiSeriesMulti">
                        <div class="col-2">
                            {{ __('series_data_is') }}
                        </div>
                        <div class="col-2">
                            <select2 :settings="selectSettings" style="width: 100%" class="vue-select" v-model="thirdOption" :options="forSimpleWithDefineXAxis" @change="handleChangeCriterium()"></select2>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="chartStatus == 1">
                        <div class="col">
                            <button type="button" class="btn btn-primary" @click="saveSettings()">{{__("save_settings")}}</button>
                            <button type="button" class="btn btn-primary" @click="saveAnalyzeAsPattern()">{{__("save_analyze_as_pattern")}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChartParameter",
    data() {
        return {
            chartType: this.chartConfig.type,
            firstOption: this.chartConfig.level_1,
            secondOption: this.chartConfig.level_2,
            thirdOption: this.chartConfig.level_3,
        }
    },
    props: {
        analyzeLevel: {
            type: Object
        },
        sbChart: {
            type: Array
        },
        analyzeCriteriaStatus:{
            type: Object
        },
        chartConfig:{
            type: Object
        },
        analyzeType: {
            type: String
        },
    },
    methods:{
        saveSettings(){
            this.$emit('saveSettings', this.chartType, this.firstOption,this.secondOption,this.thirdOption)
        },
        saveAnalyzeAsPattern(){
            this.$emit('saveAnalyzeAsPattern', this.chartType, this.firstOption,this.secondOption,this.thirdOption)
        },
        handleChartTypeChange(){
            this.$emit('chartTypeChange', 'name',this.chartType)
            this.$emit('chartTypeChange', 'complete',this.chartStatus)
        },
        handleChangeCriterium(){
            this.$emit('chartTypeChange', 'crit_1', this.firstOption)
            this.$emit('chartTypeChange', 'crit_2', this.secondOption)
            this.$emit('chartTypeChange', 'crit_3', this.thirdOption)
            this.$emit('chartTypeChange', 'complete',this.chartStatus)
        }
    },
    computed: {
        selectSettings(){
            return {
                templateResult: (option) => {
                    if (option.id == 0 ) return option.text;
                    if([this.firstOption, this.secondOption, this.thirdOption].includes(option.id)) return null;

                    return option.text
                },
            };
        },
        chartStatus(){
            if(this.isSimpleWithDefineXAxis || this.isSimpleWithDefineBars || this.isSimpleWithSlice || this.isSimpleRadar){
                return this.firstOption != 0;
            }
            if(this.isMultiLine || this.isLineSynchronized || this.isColumnBasic || this.isStackedColumn || this.isBarGrouped || this.isStackedBar || this.isRadarMultiSeries
            || this.isAreaBasicMultiOrColumnWithDataLabelMulti || this.isSimplePieOrDonutMulti){
                return this.firstOption != 0 && this.secondOption != 0;
            }
            if(this.isLineManyMulti || this.isColumnBasicMulti || this.isStockedColumnMulti || this.isRadarMultiSeriesMulti){
                return this.firstOption != 0 && this.secondOption != 0 && this.thirdOption != 0;
            }

            return false
        },
        analyzeLevelCount() {
            const { currency_segregation,date_segregation, ...filterAnalyzeLevel } = this.analyzeLevel;
            return Object.values(filterAnalyzeLevel).filter(value => value !== null && value != 0 && value != "").length;
        },
        filteredSbChart() {
            const levelGroup = this.analyzeLevelCount == 0 ? 0 : (this.analyzeLevelCount > 1 ? this.analyzeLevelCount : 1);
            return this.sbChart.filter(record => record.level_group == levelGroup);
        },
        chartOptions() {
            let result = [{
                'text': '---', id: 0,
            }];
            for (let i = 0; i < this.filteredSbChart.length; i++) {
                result.push({text: this.__(this.filteredSbChart[i].name), id: this.filteredSbChart[i].name})
            }
            return result
        },
        isSimpleWithDefineXAxis(){
            return ['line_basic', 'area_basic', 'column_with_data_labels', 'column_with_rotated_labels', 'column_with_data_inside'].includes(this.chartType)
        },
        isSimpleWithDefineBars(){
            return ['bar_basic', 'bar_with_category_name_and_label_inside'].includes(this.chartType)
        },
        isSimpleWithSlice(){
            return ['simple_pie', 'simple_donut', 'monochrome_pie', 'gradient_donut', 'semi_donut'].includes(this.chartType)
        },
        isSimpleRadar(){
            return ['radar_basic'].includes(this.chartType)
        },
        isMultiLine(){
            return ['line_many'].includes(this.chartType)
        },
        isLineSynchronized(){
            return ['line_synchronized'].includes(this.chartType)
        },
        isColumnBasic(){
            return ['column_basic'].includes(this.chartType)
        },
        isStackedColumn(){
            return ['stacked_column', 'stacked_column_100'].includes(this.chartType)
        },
        isBarGrouped(){
            return ['bar_grouped',].includes(this.chartType)
        },
        isStackedBar(){
            return ['stacked_bar', 'stacked_bar_100'].includes(this.chartType)
        },
        isRadarMultiSeries(){
            return ['radar_multi_series'].includes(this.chartType)
        },
        isAreaBasicMultiOrColumnWithDataLabelMulti(){
            return ['column_with_data_labels_multi', 'area_basic_multi'].includes(this.chartType)
        },
        isSimplePieOrDonutMulti(){
            return ['simple_pie_multi', 'simple_donut_multi', 'monochrome_pie_multi', 'gradient_donut_multi', 'semi_donut_multi'].includes(this.chartType)
        },
        isLineManyMulti(){
            return ['line_many_multi'].includes(this.chartType)
        },
        isColumnBasicMulti(){
            return ['column_basic_multi'].includes(this.chartType)
        },
        isStockedColumnMulti(){
            return ['stacked_column_multi', 'stacked_column_100_multi'].includes(this.chartType)
        },
        isRadarMultiSeriesMulti(){
            return ['radar_multi_series_multi'].includes(this.chartType)
        },
        groupsName(){
            return {
                'contractor_item_name': this.__('groups_by_contractor_groups'),
                'order_item_name': this.__('groups_by_item_groups'),
                'date_item_name': this.analyzeLevel.date_segregation == 'year' ? this.__('years_2') : this.__('groups_by_months'),
                'currency_item_name' : this.__('groups_by_currency')
            }
        },
        forSimpleWithDefineXAxis(){
            const map = {
                'contractor':'contractor_item_name',
                'item':"order_item_name",
                "date":"date_item_name",
                "currency":"currency_item_name"
            }
            let result = [];
            result.push({
                id: 0,
                text: '---'
            })
            if(![0, '', null].includes(this.analyzeLevel.analyze_level_1) && this.analyzeCriteriaStatus[this.analyzeLevel.analyze_level_1] == 'ready'){
                result.push({
                    id: map[this.analyzeLevel.analyze_level_1],
                    text: this.__(this.groupsName[map[this.analyzeLevel.analyze_level_1]])
                })
            }
            if(![0, '', null].includes(this.analyzeLevel.analyze_level_2) && this.analyzeCriteriaStatus[this.analyzeLevel.analyze_level_2] == 'ready'){
                result.push({
                    id: map[this.analyzeLevel.analyze_level_2],
                    text: this.__(this.groupsName[map[this.analyzeLevel.analyze_level_2]])
                })
            }
            if(![0, '', null].includes(this.analyzeLevel.analyze_level_3) && this.analyzeCriteriaStatus[this.analyzeLevel.analyze_level_3] == 'ready'){
                result.push({
                    id: map[this.analyzeLevel.analyze_level_3],
                    text: this.__(this.groupsName[map[this.analyzeLevel.analyze_level_3]])
                })
            }
            return result;

        }
    },
    mounted() {
        this.handleChartTypeChange()
        this.handleChangeCriterium()
    }
}
</script>

<style scoped>

</style>
